// extracted by mini-css-extract-plugin
export default {"wrapper":"SwitchInput_wrapper__wapI0","typeWrapper":"SwitchInput_typeWrapper__10KVw","inputItem":"SwitchInput_inputItem__u97vU","input":"SwitchInput_input__g2obN"};